import React, { useState, useEffect } from "react";
import styled from "styled-components";

import { handleVolume } from "../actions";
import Slider from "@material-ui/core/Slider";
import MaterialIconButton from "@material-ui/core/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Row, Text, HGap } from "../../../comps";

import { faVolumeUp } from "@fortawesome/free-solid-svg-icons";

const VolumeWrapper = styled(Row)`
  height: 100%;
  align-items: center;
`;

const VolumeSlider = styled.div`
  width: 0px;
  overflow: hidden;
  transition: width 400ms ease;
  ${VolumeWrapper}:hover & {
    width: 80px;
  }
`;
export default ({ volume }) => {
  const [v, setV] = useState(100);
  const [done, setDone] = useState(false);

  const handleChange = (event, val) => {
    setV(Math.floor(val));
    handleVolume(Math.floor(val));
  };

  useEffect(() => {
    if (!done) {
      setV(volume || 100);
      setDone(true);
    }
  }, [volume]);

  return (
    <VolumeWrapper>
      <MaterialIconButton>
        <FontAwesomeIcon
          style={{ fontSize: "18px", color: "#fff" }}
          icon={faVolumeUp}
        />
      </MaterialIconButton>
      <VolumeSlider>
        <Slider
          min={0}
          max={100}
          value={v}
          onChange={handleChange}
          aria-labelledby="continuous-slider"
          style={{ color: `#fff` }}
        />
      </VolumeSlider>
    </VolumeWrapper>
  );
};
